import React from 'react'
import { Link, NavLink } from 'react-router-dom'

import LogoutButton from '../felles/logoutbutton'
import NKIcon from '@norkart/ikoner'


import './meny.css'

export default class MenySide extends React.Component {
    constructor() {
        super()

        this.state = {
            collapsed: false
        }   
        this.toggleNav = this.toggleNav.bind(this)
        this.hideNav = this.hideNav.bind(this)
        this.showNav = this.showNav.bind(this)
    }

    toggleNav() {
        this.setState({ collapsed: !this.state.collapsed })
    }

    hideNav() {
        this.setState({ collapsed: false })
    }

    showNav() {
        this.setState({ collapsed: true })
    }

    render() {

        return (
            <nav className="navbar navbar-inverse sidebar navbar-fixed-top">
                <div className="container-fluid">
                    <div className="navbar-header">
                        <button type="button" className="navbar-toggle"  onClick={this.toggleNav}>
                            <span className="sr-only">Toggle navigation</span>
                            <span className="icon-bar" />
                            <span className="icon-bar" />
                            <span className="icon-bar" />
                        </button>
                        <Link id="brannlogo" className="brannlogo" to="/forside">
                            <div>
                                <img
                                    className="pull-right sk-logo"
                                    src={process.env.PUBLIC_URL + '/images/NORKART_SYMBOL_negativ__digital.png'}
                                    alt={this.props.name}
                                    style={{ width: '40px' }}
                                />
                                <span className="brannBrand">Vannmålerbytte</span>
                            </div>
                        </Link>
                    </div>
                    <div
                        className={`collapse navbar-collapse ${this.state.collapsed ? 'in' : null}`}
                    >
                        <ul className="nav navbar-nav sb-navbar">
                            <li>
                                <NavLink to="/planlegging" activeClassName="active" onClick={this.hideNav}>
                                    Planlegging
                                    <span className="pull-right">
                                        <NKIcon icon="kalender" size="1" color="nk-white" />
                                    </span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/utskiftning" activeClassName="active" onClick={this.hideNav}>
                                Utskiftning
                                    <span className="pull-right">
                                        <NKIcon icon="gjennomforing" size="1" color="nk-white" />
                                    </span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/innstillinger" activeClassName="active" onClick={this.hideNav}>
                                Innstillinger
                                    <span className="pull-right">
                                        <NKIcon icon="innstillinger" size="1" color="nk-white" />
                                    </span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/rapporter" activeClassName="active" onClick={this.hideNav}>
                                Rapporter
                                    <span className="pull-right">
                                        <NKIcon icon="rapport" size="1" color="nk-white" />
                                    </span>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/hjelp" activeClassName="active" onClick={this.hideNav}>
                                Hjelp
                                    <span className="pull-right">
                                        <NKIcon icon="hjelp" size="1" color="nk-white" />
                                    </span>
                                </NavLink>
                            </li>
                            <LogoutButton />
                        </ul>
                    </div>
                </div>
            </nav>
        )
    }
}



// WEBPACK FOOTER //
// ./src/meny/menyside.jsx